import type { RouteRecordRaw } from 'vue-router'

import { ROUTES as AUTH_ROUTES } from '../../auth/route-names'

import { ROUTE_NAMES } from './constant'

const routes: RouteRecordRaw[] = [
  {
    path: 'policy/:policyId',
    name: ROUTE_NAMES.POLICY_DETAILS,
    component: () => import('./pages/PolicyDetails/PolicyDetails.vue'),
    meta: {
      owners: ['bot-squad-b2cservices-front'],
      auth: { required: true, redirection: { name: AUTH_ROUTES.AUTH.LOGIN } },
    },
  },
]
export default routes
